import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  arrowIcon: {
    fontSize: '1.3rem',
    color: theme.custom.darkBlue,
  },
  iconBtn: {
    minWidth: 25,
    '&.Mui-disabled': {
      opacity: '.3',
    },
  },
  title: {
    margin: 0,
    marginTop: 10,
    fontSize: 16,
    fontWeight: 600,
    color: theme.custom.darkBlue,
  },
  text: {
    display: 'block',
    fontSize: 14,
    color: theme.custom.darkBlue,
  },
  bold: {
    fontWeight: 600,
  },
  greyish: {
    marginTop: 10,
    color: 'rgba(48, 52, 75, .7)',
  },
}));
